import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class ApiClient {
  constructor(httpClient) {
    _defineProperty(this, "httpClient", void 0);
    this.httpClient = httpClient;
  }
  requestOptions(instance, options) {
    return {
      headers: {
        Authorization: instance,
        'Content-Type': 'application/json',
        ...options
      }
    };
  }
  async get(url, instance) {
    const res = await this.httpClient.get(url, this.requestOptions(instance));
    return res.data;
  }
  async del(url, instance) {
    const res = await this.httpClient.delete(url, this.requestOptions(instance));
    return res.data;
  }
  async post(url, instance, data, options) {
    const res = await this.httpClient.post(url, data || {}, this.requestOptions(instance, options));
    console.log('>>>>> post = ', res.data);
    return res.data;
  }
  async put(url, instance, data) {
    const res = await this.httpClient.put(url, data || {}, this.requestOptions(instance));
    return res.data;
  }

  // req: HttpRequestOrHttpRequestFactory<T>, overrides?: RequestOverrides
  async request(req) {
    const res = await this.httpClient.request(req);
    return res.data;
  }
  async performAPIRequest(_ref) {
    let requestPromise = _ref.requestPromise,
      context = _ref.context,
      _ref$isArr = _ref.isArr,
      isArr = _ref$isArr === void 0 ? false : _ref$isArr;
    try {
      const response = await requestPromise;
      return response;
    } catch (e) {
      const error = e;
      console.error(`Error during ${context}:`, error.message);
      if (isArr) {
        return [];
      }
      return {};
    }
  }
}
//# sourceMappingURL=ApiClient.js.map